const config = {
	appName: 'DIYFeed',
	auth0domain: <string>process.env.REACT_APP_AUTH0_DOMAIN,
	auth0ClientId: <string>process.env.REACT_APP_AUTH0_CLIENT_ID,
	remoteApiAccountsUrl: <string>process.env.REACT_APP_REMOTE_API_ACCOUTS_URL,
	gaMeasurementId: <string>process.env.REACT_APP_GA_MEASUREMENT_ID,
	j2sWorkspaceRoot: <string>process.env.REACT_APP_J2S_WORKSPACE_ROOT,
	j2sResolver: <'cursor' | 'vscode'>process.env.REACT_APP_J2S_RESOLVER,
	metaPixelId: <string>process.env.REACT_APP_META_PIXEL_ID,
};

export default config;
